
import Icon from '@/components/Icon.vue'
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'GuideContent',
  components: { Icon },
  props: {
    abs: Boolean,
    anchorPosition: {
      type: String,
      default: 'top',
    },
    anchorAlign: {
      type: Number,
      default: 10,
    },
  },
  data () {
    return {
      show: true,
    }
  },
  methods: {
    gotIt () {
      this.show = false
    },
  },
})
